import { render, staticRenderFns } from "./FormRegistrator.vue?vue&type=template&id=ef1b77f0&scoped=true&"
import script from "./FormRegistrator.vue?vue&type=script&lang=js&"
export * from "./FormRegistrator.vue?vue&type=script&lang=js&"
import style0 from "./FormRegistrator.vue?vue&type=style&index=0&id=ef1b77f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1b77f0",
  null
  
)

export default component.exports